import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AboutIntro from "./sections/AboutIntro";
import Footer from "@/reusable_sections/Footer";
import TrustBacking from "./sections/TrustBacking";
export default function AboutPage() {
  return <div>
      <Header />
      <AboutIntro />
      <TrustBacking />
      <Footer />
    </div>;
}